export enum PaymentsDashboardRouteName {
  home = 'payments-dashboard',
}
